export default "__VITE_ASSET__DnPRUqDW__"